import moment from "moment";
import "moment/locale/bg";
import "moment/locale/cs";
import "moment/locale/de";
import "moment/locale/es";
import "moment/locale/fr";
import "moment/locale/hr";
import "moment/locale/hu";
import "moment/locale/it";
import "moment/locale/kk";
import "moment/locale/nl";
import "moment/locale/pl";
import "moment/locale/pt";
import "moment/locale/ro";
import "moment/locale/ru";
import "moment/locale/sk";
import "moment/locale/sr";
import "moment/locale/tr";
import "moment/locale/uk";
import LocaleUtil from "../uidispatcherapi/LocaleUtil";
export default function setupMomentLocale(): void {
	const localeShort = LocaleUtil.getLocale().substring(0, 2);
	moment.locale(localeShort);
}
